import React from 'react'
import Search from '../users/Search'
import Users from '../users/Users'

const Home = () => 
  <React.Fragment>
    <Search />
    <Users />
  </React.Fragment>

export default Home
